import { useI18n } from '../lib/i18n'
import { touchedRecently } from '../lib/passkeys'

/**
 * «Te pediremos tu clave de acceso para confirmarlo.», only when it will be asked: within
 * minutes of the last touch in this tab, the sign-in's included, the action goes on without it
 * (components/reauth.tsx, ADR 0008 §4), and nothing is said (null). Decided as it is drawn.
 */
export function usePasskeyNote(): string | null {
  const { t } = useI18n()
  return touchedRecently() ? null : t('company.passkeyNote')
}

/** The note as a paragraph of its own; a field's hint takes `usePasskeyNote` instead. */
export function PasskeyNote({ className }: { className?: string }) {
  const note = usePasskeyNote()
  return note === null ? null : <p className={className}>{note}</p>
}
